/**
 * Custom element that renders the omnibus (lowest 30-day) price for the active variant.
 *
 * On variant change Horizon fires a `variant:update` event on the nearest
 * `.shopify-section` parent and attaches a freshly-rendered DOM tree under
 * `event.detail.data.html`. We find our counterpart element in that tree by
 * `data-block-id` and swap our inner HTML in-place, matching the same HTML-swap
 * pattern used by the theme's own `product-price` component.
 */
class DevOmnibusPrice extends HTMLElement {
  connectedCallback() {
    this._section = this.closest('.shopify-section, dialog');
    if (!this._section) return;
    this._section.addEventListener('variant:update', this._onVariantUpdate);
  }

  disconnectedCallback() {
    if (!this._section) return;
    this._section.removeEventListener('variant:update', this._onVariantUpdate);
  }

  _onVariantUpdate = (event) => {
    const html = event.detail?.data?.html;
    if (!html) return;

    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const updated = html.querySelector(`dev-omnibus-price[data-block-id="${this.dataset.blockId}"]`);
    if (!updated) return;

    this.innerHTML = updated.innerHTML;
  }
}

if (!customElements.get('dev-omnibus-price')) {
  customElements.define('dev-omnibus-price', DevOmnibusPrice);
}
